<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <LoginEmbedded />
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import LoginEmbedded from '@/components/login/embedded'

export default {
  name: 'view-login-embedded',
  components: { LoginEmbedded }
}
</script>

<style scoped>
</style>
